import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { LoginPageRoutingModule } from './login-routing.module';
import { IonicModule } from '@ionic/angular';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

// const isIE =
//   window.navigator.userAgent.indexOf('MSIE ') > -1 ||
//   window.navigator.userAgent.indexOf('Trident/') > -1; // Remove this line to use Angular Universal

// export function loggerCallback(logLevel: LogLevel, message: string) {
//   //console.log(message);
// }

// export function MSALInstanceFactory(): IPublicClientApplication {
//   //console.log('We are getting MSALInstanceFactory instance');
//   return new PublicClientApplication({
//     auth: {
//       //      clientId: 'f4299fca-0b4d-40a9-915b-deca45bc3515', // B2B AD
//       clientId: 'b2fd4ab3-145a-47bb-8d19-c15252f71e2d', // B2C AD
//       authority: 'https://login.microsoftonline.com/4967f11e-370c-45dd-b669-58328a27787b',
//       // authority: 'https://login.microsoftonline.com/common',
//       redirectUri: '',
//       postLogoutRedirectUri: ''
//     },
//     cache: {
//       cacheLocation: BrowserCacheLocation.LocalStorage,
//       storeAuthStateInCookie: isIE // set to true for IE 11. Remove this line to use Angular Universal
//     },
//     system: {
//       loggerOptions: {
//         loggerCallback,
//         logLevel: LogLevel.Info,
//         piiLoggingEnabled: false
//       }
//     }
//   });
// }

// export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
//   //console.log('We are getting MSALInterceptorConfigFactory instance');
//   const protectedResourceMap = new Map<string, Array<string>>();
//   protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', [
//     'user.read'
//   ]);

//   return {
//     interactionType: InteractionType.Redirect,
//     protectedResourceMap
//   };
// }

// export function MSALGuardConfigFactory(): MsalGuardConfiguration {
//   //console.log('We are getting MSALGuardConfigFactory instance');
//   return {
//     interactionType: InteractionType.Redirect,
//     authRequest: {
//       scopes: ['user.read']
//     },
//     loginFailedRoute: '/login-failed'
//   };
// }

@NgModule({
  declarations: [
    LoginComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LoginPageRoutingModule,
    SharedModule,
    IonicModule
  ],
  // providers: [
  //   {
  //     provide: HTTP_INTERCEPTORS,
  //     useClass: MsalInterceptor,
  //     multi: true
  //   },
  //   {
  //     provide: MSAL_INSTANCE,
  //     useFactory: MSALInstanceFactory
  //   },
  //   {
  //     provide: MSAL_GUARD_CONFIG,
  //     useFactory: MSALGuardConfigFactory
  //   },
  //   {
  //     provide: MSAL_INTERCEPTOR_CONFIG,
  //     useFactory: MSALInterceptorConfigFactory
  //   },
  //   MsalService,
  //   MsalGuard,
  //   MsalBroadcastService
  // ],
})
export class LoginPageModule {}